// extracted by mini-css-extract-plugin
export default {"amp_logo":"header_amp_logo__CusNp"};